function AuthFunction({ firebase, session, command, provider, email }) {
    switch (command) {
        case "signout":
        case "logout":
            session.setBypassed(true)
            firebase
                .auth()
                .signOut()
                .then(function() {
                    console.log("SIGNED OUT")
                    session.setUser({
                        email: "ANONYMOUS",
                        uid: "anonymous",
                    })
                })
                .catch(function(error) {
                    console.log(error)
                })
        case "login":
        case "signin":
            switch (provider) {
                case "google":
                case "GOOGLE":
                    firebase.auth().signInWithRedirect(new firebase.auth.GoogleAuthProvider())
                case "emailpw":
                    var actionCodeSettings = {
                        url: "https://disruptionresearch.firebaseapp.com/emailsignin",
                        handleCodeInApp: true,
                    }
                    firebase
                        .auth()
                        .sendSignInLinkToEmail(email, actionCodeSettings)
                        .then(function() {
                            window.localStorage.setItem("emailForSignIn", email)
                        })
                        .catch(function(error) {
                            console.log(error)
                        })
            }
    }
}

export default AuthFunction

//problem calling this...
